module.exports = __webpack_public_path__ + "img/phone.eee7cb8b.png";